export const emojiReactionsEn = {
  andMore: (count: number) => `... и ещё ${count}`
}

export const emojiReactionsRu: typeof emojiReactionsEn = {
  andMore: (count: number) => `... and ${count} more`
}
